module.exports = __webpack_public_path__ + "static/img/__9999.cb082ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9999.jpg
// module id = 4IWn
// module chunks = 0